<template>
    <div class="z-not-found">
        <div class="z-not-found__description">
            <template v-if="!!this.$slots['description']">
                <slot name="description"></slot>
            </template>
            <template v-else>
                <z-caption size="xl" tag="h1" class="black-text">
                    <span v-if="text" v-html="text.title" />
                    <span v-else v-html="textDefault.title" />
                </z-caption>
                <p v-if="text" class="z-not-found__tip" v-html="text.description" />
                <p v-else class="z-not-found__tip" v-html="textDefault.description" />
            </template>
        </div>
        <div class="z-not-found__image">
            <z-image :src="image"></z-image>
        </div>
    </div>
</template>

<script>
import { localize } from '@/utils/i18n'

export default {
    name: 'z-not-found',
    props: {
        image: {
            type: String,
            default: '/images/not-found-imageholder.jpg'
        },
        text: {
            type: Object
        }
    },
    data () {
        return {
            textDefault: {
                title: localize({
                    ru: 'По вашему запросу ничего не&nbsp;найдено',
                    en: 'No matches were found for your query'
                }),
                description: localize({
                    ru: 'Попробуйте изменить параметры поиска',
                    en: 'Try changing your search parameters'
                })
            }
        }
    }
}
</script>

<style lang="scss">

.z-not-found {
    display: flex;

    @include breakpoint (v-tablet) {
        display: block;
    }

    &__description {
        position: relative;
        padding: $token-spacers-m $token-spacers-l;
        flex: 0 0 54%;
        max-width: 54%;
        min-height: 410px;
        margin-bottom: auto;
        z-index: 1;
        background-color: #F2F2F6;
        box-shadow: 0 33px 85px rgba(0, 0, 0, 0.07), 0 7.37098px 18.9859px rgba(0, 0, 0, 0.0417275), 0 2.19453px 5.65259px rgba(0, 0, 0, 0.0282725);

        @include breakpoint (tablet) {
            padding: $token-spacers-s $token-spacers-m;
            min-height: 318px;
        }

        @include breakpoint (v-tablet) {
            // flex: 0 0 100%;
            max-width: 100%;
            min-height: 278px;
            padding: $token-spacers-m $token-spacers-2-xs;
            box-shadow: none;
        }

        &:before {
            content: '';
            background-image: url(/images/logo/logo-onetone--small.svg);
            width: 232px;
            height: 232px;
            background-repeat: no-repeat;
            background-size: cover;
            position: absolute;
            right: 0;
            bottom: 1px;
            z-index: -1;

            @include breakpoint (tablet) {
                width: 178px;
                height: 178px;
            }

            @include breakpoint (v-tablet) {
                width: 126px;
                height: 126px;
            }
        }
    }

    &__tip {
        font-weight: 500;
        font-size: 16px;

        @include breakpoint (mobile) {
            font-size: 14px;
            font-weight: 400;
        }
    }

    &__image {
        margin-top: $token-spacers-l;
        margin-left: -$token-spacers-3-xl;
        z-index: 0;

        @include breakpoint (v-tablet) {
            margin-top: 0;
            margin-left: 0;

            .z-image,
            img {
                width: 100%;
            }
        }
    }
}

</style>
